import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M9.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75ZM9 18a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 18ZM6.125 7.128c0-.904-.52-1.496-1.656-1.496-.527 0-1 .125-1.391.316a.279.279 0 0 0-.12.378l.05.1a.318.318 0 0 0 .408.145c.301-.124.603-.195.965-.195.504 0 .76.216.76.72a.287.287 0 0 1-.288.288h-.496c-1.112 0-1.768.488-1.768 1.232v.28c0 .752.664 1.208 1.416 1.208.38 0 .733-.103 1.044-.327.1-.072.252-.024.276.097a.155.155 0 0 0 .152.126h.348a.3.3 0 0 0 .3-.3V7.128Zm-1.06 1.905a1.216 1.216 0 0 1-.868.335c-.424 0-.624-.216-.624-.552v-.16c0-.432.296-.648.88-.648h.388a.3.3 0 0 1 .3.3v.533a.265.265 0 0 1-.076.192Zm1.429 6.615c0-1.232-.64-2.016-1.616-2.016-.173 0-.332.022-.477.064-.26.075-.627-.094-.627-.363v-.953a.3.3 0 0 0-.3-.3h-.392a.3.3 0 0 0-.3.3v5.32a.3.3 0 0 0 .3.3h.362a.141.141 0 0 0 .138-.111c.024-.11.162-.15.253-.083.258.193.563.298.923.298.976 0 1.736-.848 1.736-2.024v-.432Zm-.992-.032v.496c0 .816-.36 1.248-.912 1.248a1.07 1.07 0 0 1-.732-.277.266.266 0 0 1-.084-.201v-1.937a.27.27 0 0 1 .068-.184c.21-.228.49-.377.836-.377.544 0 .824.4.824 1.232Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListLowercaseAlphabetIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListLowercaseAlphabet')) as IconWithRender;

TextListLowercaseAlphabetIcon.displayName = 'TextListLowercaseAlphabetIcon';
TextListLowercaseAlphabetIcon.propTypes = Icon.propTypes;
TextListLowercaseAlphabetIcon.renderIcon = (props) => (
  <TextListLowercaseAlphabetIcon {...props} />
);
export default TextListLowercaseAlphabetIcon;
